import { defineMessages } from 'react-intl';

export const scope =
  'src.pages.ProjectDetailsPage.components.JobDetails.components.JobDateFilter';

export default defineMessages({
  allJobDatesLabel: {
    id: `${scope}.allJobDatesLabel`,
    defaultMessage: 'All',
  },
});
